/**
 * @file Components/Sections/ServicesSection.jsx
 * @description Services grid section using ServiceCard components
 * to display available travel services in a responsive layout.
 */

import React from 'react';
import ServiceCard from '../Ui/ServiceCard';
import { FaGlobeAmericas, FaHotel, FaBusAlt, FaLandmark } from 'react-icons/fa';

const services = [
  {
    icon: <FaGlobeAmericas />,
    title: 'Customized Tours',
    description: 'Experience personalized travel itineraries tailored to your preferences. From solo adventures to family vacations, we ensure a seamless journey.',
    features: [
      { name: 'Tailor-made Itineraries', available: true },
      { name: 'Expert Travel Planners', available: true },
      { name: 'Flexible Travel Dates', available: true },
      { name: '24/7 Support', available: true },
      { name: 'Group Discounts', available: false },
    ],
  },
  {
    icon: <FaHotel />,
    title: 'Luxury Hotels',
    description: 'Indulge in the finest accommodations with our luxury hotel selections. Enjoy comfort, premium amenities, and world-class hospitality.',
    features: [
      { name: '5-Star Accommodations', available: true },
      { name: 'Spa and Wellness Services', available: true },
      { name: 'Exclusive Dining Options', available: true },
      { name: 'Personalized Room Services', available: true },
      { name: 'Budget Stays', available: false },
    ],
  },
  {
    icon: <FaBusAlt />,
    title: 'Comfortable Transport',
    description: 'Travel in comfort with our reliable transport services. From private vehicles to luxury coaches, we ensure a hassle-free journey.',
    features: [
      { name: 'Private Car Rentals', available: true },
      { name: 'Airport Transfers', available: true },
      { name: 'Luxury Bus Services', available: true },
      { name: 'Multilingual Drivers', available: true },
      { name: 'Budget Transport', available: false },
    ],
  },
  {
    icon: <FaLandmark />,
    title: 'Selective Sightseeing',
    description: 'Discover iconic landmarks and hidden gems with our curated sightseeing tours led by expert local guides.',
    features: [
      { name: 'Historical Landmarks', available: true },
      { name: 'Cultural Experiences', available: true },
      { name: 'Nature and Wildlife Tours', available: true },
      { name: 'Adventure Activities', available: true },
      { name: 'Self-Guided Options', available: false },
    ],
  },
];




const ServiceSection = () => {
  return (
    <div className="container mx-auto py-12">
      <h1 className='text-center text-5xl font-extrabold mb-8'>Our Services</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {services.map((service, index) => (
          <ServiceCard key={index} {...service} />
        ))}
      </div>
    </div>
  );
};

export default ServiceSection;